document.addEventListener('key:options:ready', () => {
	KeyOptions.on('price-updated', ({ totalPriceCents }) => {
		const totalContainer = document.querySelector('.key_option_set + div');
		setTimeout(() => translateTotal(totalContainer), 0);
	});
});

function translateTotal(element) {
	const translations = {
		"Total Extras": "Total des options",
		"Base Product Price:": "Prix de base du produit:",
		"Total Price:": "Prix total:"
	};

	const walker = document.createTreeWalker(
		element,
		NodeFilter.SHOW_TEXT,
		null,
		false
	);

	let node;
	while ((node = walker.nextNode())) {
		const originalText = node.nodeValue.trim();

		if (translations[originalText]) {
			node.nodeValue = node.nodeValue.replace(originalText, translations[originalText]);
		}
	}
}
